export default __webpack_public_path__ + "static/media/blood-tubing.61342b41.jpg";